import api from "../proxy/config";
import { verboseApiErrorsInTest } from "../config/featureConfig";
import { formatAxiosErrorMessage } from "../utils/verboseHttpError";
import axios from "./axiosConfig";

const handleBackendError = (error, defaultMsg) => {
  if (
    error.response?.status === 500
    || (typeof error.response?.data === "string" && error.response.data.includes("Internal Server Error"))
  ) {
    throw new Error("Si è verificato un problema, riprova più tardi.");
  }
  const backendError = error.response?.data;
  const message = typeof backendError === "string"
    ? backendError
    : (backendError?.message || backendError?.error || defaultMsg);
  throw new Error(message);
};

async function tryLogin(email, passwordEncoded) {
  const response = await axios.post(
    api.login,
    { email, password: passwordEncoded, type: "admin" },
    { skipGlobalErrorHandler: true }
  );
  return response.data;
}

const login = async ({ email, password }) => {
  try {
    const passwordEncoded = btoa(password);
    return await tryLogin(email, passwordEncoded);
  } catch (error) {
    if (verboseApiErrorsInTest && !error?.response) {
      throw new Error(formatAxiosErrorMessage(error));
    }
    handleBackendError(error, "Errore durante il login");
  }
  return null;
};

function readStoredToken() {
  const savedToken = sessionStorage.getItem("token");
  if (!savedToken || savedToken === "undefined") {
    return null;
  }

  try {
    return JSON.parse(savedToken);
  } catch {
    return savedToken;
  }
}

export const refresh = async () => {
  try {
    const token = readStoredToken();
    if (!token) {
      throw new Error("Token non trovato nella sessione.");
    }

    const response = await axios.post(
      api.refresh,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
        skipGlobalErrorHandler: true,
      }
    );

    if (response.data?.token) {
      sessionStorage.setItem("token", JSON.stringify(response.data.token));
    }

    return response.data;
  } catch (error) {
    handleBackendError(error, "Sessione scaduta o non valida");
  }
  return null;
};

const clientTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};

export const requestRecoverPassword = async (email) => {
  try {
    const response = await axios.post(api.requestRecoverPassword, { email, timeZone: clientTimeZone() });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore nella richiesta di recupero");
  }
  return null;
};

export const resetPassword = async (token, newPassword) => {
  try {
    const passwordEncoded = btoa(newPassword);
    const response = await axios.post(api.recoverPassword, {
      token,
      password: passwordEncoded,
    });
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore nel reset della password");
  }
  return null;
};

export const impersonateVendor = async (vendorId) => {
  try {
    const token = readStoredToken();
    const response = await axios.post(
      api.impersonateVendor,
      { vendorId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    handleBackendError(error, "Errore durante l'impersonificazione");
  }
  return null;
};

export default login;
